import classnames from 'classnames';
import { noop } from 'ramda-adjunct';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { FolderThumbnail } from '../../../../../../../components/common';
import { ItemName } from '../../../../../../../components/layouts/Gallery/ItemName';
import { GenericItem } from '../../../../../../../components/layouts/Generic/GenericItem';
import { useIsCurrentSite } from '../../../../../../../utils/hooks/useIsCurrentSite';
import { isWixSiteFolder } from '../../../../../../../utils/media-manager-sdk/items';
import styles from './ReadonlyFolder.scss';
import { IOuter } from './ReadonlyFolder.types';

export const ReadonlyFolder: FC<IOuter> = ({
  item,
  className,
  isSelected = false,
  onClick = noop,
  onDoubleClick = noop,
  isFilesImporterNewLayout,
  dataHookId,
}) => {
  const { isCurrentSite } = useIsCurrentSite(item);
  const { formatMessage } = useIntl();
  return (
    <GenericItem item={item} onDoubleClick={onDoubleClick} onClick={onClick} noContextMenu dataHookId={dataHookId}>
      <div
        className={classnames(styles.folder, className)}
        data-hook="file-gallery-folder"
        data-hook-selected={isSelected}
      >
        <div className={classnames(styles.thumbnailWrapper, styles.selectable, isSelected && styles.selected)}>
          <FolderThumbnail
            className={styles.thumbnail}
            folder={item}
            isFilesImporterNewLayout={isFilesImporterNewLayout}
          />
        </div>

        <div className={styles.name} data-hook="file-gallery-folder-name">
          <ItemName>
            {isWixSiteFolder(item) && isCurrentSite
              ? formatMessage(
                  {
                    id: 'files-source.label.current-site-name',
                  },
                  {
                    siteName: item.name,
                    currentSite: formatMessage({ id: 'files-source.label.current_site' }),
                  },
                )
              : item.name}
          </ItemName>
        </div>
      </div>
    </GenericItem>
  );
};
